import { StyleSheet } from 'react-native';
import { spacing } from '../../../shared/theme/spacing'
import { typography } from '../../../shared/theme/typography'
import { ticketColors, ticketFonts } from '../../../shared/theme/ticketColors';

export const posCheckoutModalStyleDefs = {
  checkoutHeroBlock: {
    gap: spacing.xs,
  },

  checkoutHeroAlerts: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: spacing.xs,
    paddingHorizontal: spacing.xs,
  },

  primaryButton: {
    backgroundColor: ticketColors.gold,
    borderRadius: 10,
    paddingVertical: spacing.md,
    alignItems: 'center',
  },

  primaryButtonText: {
    ...typography.titleLg,
    color: ticketColors.goldInk,
    fontWeight: '700',
    fontFamily: ticketFonts.sans,
  },

  secondaryButton: {
    minHeight: 44,
    borderRadius: 10,
    paddingVertical: spacing.sm + 2,
    paddingHorizontal: spacing.lg,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: ticketColors.paper,
  },

  secondaryButtonText: {
    ...typography.body,
    color: ticketColors.ink,
    fontWeight: '600',
    fontFamily: ticketFonts.sans,
  },

  modalBackdrop: {
    flex: 1,
    backgroundColor: ticketColors.dim,
    justifyContent: 'center',
  },

  sheetBackdrop: {
    flex: 1,
    backgroundColor: ticketColors.dim,
    justifyContent: 'flex-end',
  },

  sheetCard: {
    flex: 1,
    width: '100%',
    backgroundColor: ticketColors.paper,
    borderTopLeftRadius: 20,
    borderTopRightRadius: 20,
    paddingTop: 8,
    borderTopWidth: 1,
    borderColor: ticketColors.ruleSoft,
  },

  grabber: {
    width: 28,
    height: 3,
    borderRadius: 2,
    backgroundColor: ticketColors.rule,
    alignSelf: 'center',
    marginTop: 2,
    marginBottom: 12,
  },

  sheetHeader: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    paddingHorizontal: 20,
    marginBottom: 12,
  },

  sheetTitle: {
    fontSize: 13,
    fontWeight: '700',
    letterSpacing: 0.52,
    textTransform: 'uppercase',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },

  sheetCloseBtn: {
    width: 32,
    height: 32,
    borderRadius: 10,
    backgroundColor: ticketColors.paper2,
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },

  wideHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: ticketColors.ruleSoft,
  },

  wideHeaderTitle: {
    fontSize: 13,
    fontWeight: '700',
    letterSpacing: 0.52,
    textTransform: 'uppercase',
    color: ticketColors.ink2,
    fontFamily: ticketFonts.sans,
  },

  wideCloseBtn: {
    width: 32,
    height: 32,
    borderRadius: 8,
    backgroundColor: ticketColors.paper2,
    alignItems: 'center',
    justifyContent: 'center',
  },

  modalCard: {
    backgroundColor: ticketColors.paper,
    borderRadius: 18,
    padding: spacing.lg,
    gap: spacing.md,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    width: '100%',
    maxWidth: 560,
    alignSelf: 'center',
  },

  checkoutCard: {
    width: '100%',
    alignSelf: 'center',
    flexShrink: 1,
    overflow: 'hidden',
  },

  checkoutModalBodyHost: {
    flex: 1,
    minHeight: 0,
  },

  checkoutModalShell: {
    padding: spacing.md,
    marginHorizontal: spacing.xs,
    maxWidth: 560,
    alignSelf: 'center',
    width: '100%',
    borderColor: ticketColors.ruleSoft,
  },

  checkoutModalBody: {
    flex: 1,
    minHeight: 0,
  },

  /** Mobile: scroll interno dentro del maxHeight del modal. */
  checkoutModalBodyFill: {
    flex: 1,
    minHeight: 0,
  },

  checkoutScroll: {
    flex: 1,
  },

  checkoutContent: {
    gap: spacing.md,
    paddingTop: spacing.sm,
    paddingBottom: spacing.lg,
    paddingHorizontal: 20,
  },

  checkoutStickyFooter: {
    borderTopWidth: 1,
    borderTopColor: ticketColors.ruleSoft,
    paddingTop: spacing.md,
    paddingBottom: spacing.sm,
    paddingHorizontal: 20,
    gap: spacing.sm,
    backgroundColor: ticketColors.paper,
  },

  checkoutModalShellWide: {
    maxWidth: 1040,
    width: '100%',
    alignSelf: 'center',
  },

  modalTitle: {
    ...typography.titleXL,
    color: ticketColors.ink,
    fontWeight: '900',
    fontFamily: ticketFonts.sans,
  },

  modalInput: {
    borderRadius: 14,
    borderWidth: 1,
    borderColor: ticketColors.ruleSoft,
    backgroundColor: ticketColors.paper,
    paddingHorizontal: spacing.md,
    paddingVertical: spacing.sm + 2,
    color: ticketColors.ink,
    fontFamily: ticketFonts.sans,
  },

  modalActions: {
    flexDirection: 'row',
    gap: spacing.sm,
  },

  modalButtonHalf: {
    flex: 1,
    minWidth: 0,
  },

  linkText: {
    ...typography.body,
    color: ticketColors.gold,
    fontWeight: '800',
    fontFamily: ticketFonts.sans,
  },
} as const;
